import React, { createRef, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import {
    ORFSelect
    , ORFButton as Button
    , OR_RRF_InputField as InputField
    , OR_RRF_Select as Select
    , ORFSearchSuggestions as SearchSuggestions
    , ORFDropdownCheckbox
} from '../../../../../../common/forms/order-request-form.component';
import { PrimarySecondaryInt as PrimarySecondary } from "./../../../../../../../constants/external-constants"
import { newCircuitSubscriptionActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-subscription.reducer";
import { createRequestActions } from "./../../../../../../../store/external/request-reducer/create-request.reducer";

class NewCircuitSubscriptionForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSecondary: false,
            isBoth: false,
            disableSubmit: true
        }
    }

    componentDidMount() {
        this.formChanges(this.props);
    }

    componentDidUpdate(prevProps) {
        const { wirelineSubscriptionFormA } = this.props;
        if (JSON.stringify(prevProps.wirelineSubscriptionFormA) !== JSON.stringify(wirelineSubscriptionFormA)) {
            this.formChanges(prevProps);
        } else {
            return;
        }
    }

    formChanges = (prevProps) => {
        const { wirelineSubscriptionFormA } = this.props;

        let disable = wirelineSubscriptionFormA.vendorDetailId == 0
            || wirelineSubscriptionFormA.itemUseId == 0
            || wirelineSubscriptionFormA.circuitTypeId == 0
            || wirelineSubscriptionFormA.primarySecondaryId == 0
            || wirelineSubscriptionFormA.mrc == 0;

        this.primarySecondaryChanges(wirelineSubscriptionFormA.primarySecondaryId, disable);
    }

    primarySecondaryChanges = (value, disable) => {
        if (value == PrimarySecondary.secondary) {
            disable = disable || this.props.wirelineSubscriptionFormA.btnId == 0;
            this.setState({
                isSecondary: true,
                isBoth: false,
                disableSubmit: disable
            });
        } else if (value == PrimarySecondary.both) {
            disable = disable || this.props.wirelineSubscriptionFormA.mrc2 == 0;
            this.setState({
                isSecondary: false,
                isBoth: true,
                disableSubmit: disable
            });
        } else {
            this.setState({
                isSecondary: false,
                isBoth: false,
                disableSubmit: disable
            });
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        const { isSecondary, isBoth, disableSubmit } = this.state;
        const {
            //component props
            onClickCancel
            , nextAction
            , prevAction
            // form
            , wirelineSubscriptionFormA
            // reducer action
            , fetchPrimarySubscriptionByValue
            , onCategorySelect
            , onCircuitTypeSelect
            , onChangeSubCircuitType
            , onChangePrimarySecondary
            , onBTNSelect
            , onChangeMRC
            , onChangeNRC
            , onChangeMRC2
            , onChangeNRC2
        } = this.props;
        const { primarySubscriptionList } = this.props.createRequest;
        const { preferredVendorOptions, categoryOptions, circuitTypeOptions, subCircuitTypeOptions, primarySecondaryOptions, vendorDetails } = this.props.newCircuitRequest;

        return (
            <div>
                <Form method="post" role="form"
                    model="wirelineSubscriptionFormA"
                    onSubmit={nextAction}
                >
                    <div >
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('vendor')} *`}
                                    options={preferredVendorOptions}
                                    placeholder={this.toLocaleLanguage('select_a_vendor')}
                                    fieldProp='.vendorDetailId'
                                    value={wirelineSubscriptionFormA.vendorDetailId}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('category')} *`}
                                    options={categoryOptions}
                                    placeholder={this.toLocaleLanguage('select_a_category')}
                                    fieldProp='.itemUseId'
                                    value={wirelineSubscriptionFormA.itemUseId}
                                    onChangeAction={onCategorySelect}
                                    disabled={wirelineSubscriptionFormA.vendorDetailId == ''}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('circuit_type')} *`}
                                    options={circuitTypeOptions}
                                    placeholder={this.toLocaleLanguage('select_circuit_type')}
                                    fieldProp='.circuitTypeId'
                                    value={wirelineSubscriptionFormA.circuitTypeId}
                                    onChangeAction={onCircuitTypeSelect}
                                    disabled={wirelineSubscriptionFormA.vendorDetailId == ''
                                        || wirelineSubscriptionFormA.itemUseId == 0
                                    }
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Select
                                    className="form-control"
                                    label={this.toLocaleLanguage('sub_circuit_type')}
                                    options={subCircuitTypeOptions}
                                    placeholder={this.toLocaleLanguage('select_subcircuit_type')}
                                    fieldProp='.subCircuitTypeId'
                                    value={wirelineSubscriptionFormA.subCircuitTypeId}
                                    onChangeAction={onChangeSubCircuitType}
                                    disabled={wirelineSubscriptionFormA.vendorDetailId == ''
                                        || wirelineSubscriptionFormA.itemUseId == 0
                                        || wirelineSubscriptionFormA.circuitTypeId == 0
                                    }
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('primary_secondary')} *`}
                                    options={primarySecondaryOptions}
                                    placeholder={this.toLocaleLanguage('select_primary_secondary')}
                                    fieldProp='.primarySecondaryId'
                                    value={wirelineSubscriptionFormA.primarySecondaryId}
                                    onChangeAction={onChangePrimarySecondary}
                                    disabled={wirelineSubscriptionFormA.vendorDetailId == ''
                                        || wirelineSubscriptionFormA.itemUseId == 0
                                        || wirelineSubscriptionFormA.circuitTypeId == 0
                                        // Bug 27711 - This field doesn't have disabled settings based on the old version
                                        // || wirelineSubscriptionFormA.subCircuitTypeId == 0
                                    }
                                />
                            </Col>
                        </Row>
                        {isSecondary && !isBoth ?
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <SearchSuggestions
                                        value={wirelineSubscriptionFormA.btn}
                                        label={`${this.toLocaleLanguage('btn')} *`}
                                        propDisplay={'CircuitCode'}
                                        options={primarySubscriptionList.length > 0 ? primarySubscriptionList : ''}
                                        onChangeAction={onBTNSelect}
                                        searchAction={fetchPrimarySubscriptionByValue}
                                    />
                                </Col>
                            </Row> : null
                        }
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <InputField
                                    className="form-control"
                                    type="number"
                                    label={`${this.toLocaleLanguage('mrc')} *`}
                                    value={wirelineSubscriptionFormA.mrc}
                                    fieldProp='.mrc'
                                    onChangeAction={onChangeMRC}
                                    disabled={wirelineSubscriptionFormA.vendorDetailId == ''}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <InputField
                                    className="form-control"
                                    type="number"
                                    label={this.toLocaleLanguage('nrc')}
                                    value={wirelineSubscriptionFormA.nrc}
                                    fieldProp='.nrc'
                                    onChangeAction={onChangeNRC}
                                    disabled={wirelineSubscriptionFormA.vendorDetailId == ''}
                                />
                            </Col>
                        </Row>
                        {isBoth ?
                            <div>
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="number"
                                            label={`${this.toLocaleLanguage('mrc2')} *`}
                                            value={wirelineSubscriptionFormA.mrc2}
                                            fieldProp='.mrc2'
                                            onChangeAction={onChangeMRC2}
                                            disabled={wirelineSubscriptionFormA.vendorDetailId == ''}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="number"
                                            label={this.toLocaleLanguage('nrc2')}
                                            value={wirelineSubscriptionFormA.nrc2}
                                            fieldProp='.nrc2'
                                            onChangeAction={onChangeNRC2}
                                            disabled={wirelineSubscriptionFormA.vendorDetailId == ''}
                                        />
                                    </Col>
                                </Row>
                            </div> : null
                        }
                        <div className="price-plan-total-cost-container">
                            <div className="price-plan-header">
                                <span>{this.toLocaleLanguage('capital_total_cost')}</span>
                            </div>
                            <div className="price-plan-total">
                                <span>{vendorDetails.Currency}</span>
                                <span>{wirelineSubscriptionFormA.totalCost.toFixed(2)}</span>
                            </div>
                        </div>
                        <div className="request-button-continer">
                            <div className="bottom-left">
                                <Button
                                    label={this.toLocaleLanguage('modal_close_cancel_button')}
                                    variant={"light"}
                                    action={onClickCancel}
                                    type="button"
                                />
                            </div>
                            <div className="bottom-right">
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('back')}
                                        variant={"outline-secondary"}
                                        action={prevAction}
                                    />
                                </div>
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('next_button')}
                                        variant={"primary"}
                                        type={"submit"}
                                        disabled={disableSubmit}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { newCircuitRequest, createRequest, translation } = state;
        const { wirelineSubscriptionFormA } = state.form;
        return {
            newCircuitRequest
            , wirelineSubscriptionFormA
            , createRequest
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newCircuitSubscriptionActions, createRequestActions),
            dispatch
        )
)(NewCircuitSubscriptionForm);
